import { defineComponent } from "vue";
export default defineComponent({
    props: {
        mainColor: { type: String, default: "bg-brand-orange" },
        value: { type: String, default: "" },
        size: { type: Number, default: 3 },
        borderColor: { type: String, default: "bg-signal-alt-high" }
    }
});
